import gql from 'graphql-tag';

export const queryIntegrationItemWebURL = gql`
  query integrationItemWebURL(
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    integrationItemWebURL(
      integrationID: $integrationID
      remoteID: $remoteID
    )
  }
`;

export default queryIntegrationItemWebURL;
